export const checkIsImage = (path) => {
	return (
		path &&
		(path.toLowerCase().includes('png') ||
			path.toLowerCase().includes('jpg') ||
			path.toLowerCase().includes('jpeg') ||
			path.toLowerCase().includes('gif'))
	);
};
